import { ItemList } from '../../orm'
import { download } from '../../actions/lib'

class AdminOfflineTopupTransactionList extends ItemList {
    getEntityKey() {
        return "admin/offline_topup_transaction"
    }
    
}

export const adminOfflineTopupTransactionList = new AdminOfflineTopupTransactionList("admin_offline_topuptransaction__default")
